import axios, {AxiosResponse} from 'axios'
import {ID, WoosatTelecomResponse, Response} from '../../../../../_metronic/helpers'
import {Supplier, SuppliersQueryResponse} from './_models'
import toast from 'react-hot-toast'

const API_URL = process.env.REACT_APP_THEME_API_URL
const SUPPLIER_URL = `${API_URL}/admin/suppliers`
const GET_SUPPLIERS_URL = `${API_URL}/admin/suppliers`

const getSuppliers = (query: string): Promise<SuppliersQueryResponse | WoosatTelecomResponse<Supplier[]>> => {
  return axios
    .get(`${GET_SUPPLIERS_URL}?${query}`)
    .then((d: AxiosResponse<WoosatTelecomResponse<Supplier[]>>) => {
      return d.data
    })
}

const getSupplierById = async (id: ID): Promise<Supplier> => {
  try {
    const {data} = await axios.get(`${SUPPLIER_URL}/${id}`)
    return data?.data?.supplier
  } catch (error: any) {
    console.log('Error: ', error.message)
    return {}
  }
  // return axios.get(`${SUPPLIER_URL}/${id}`).then((response: AxiosResponse<Supplier>) => response.data)
}
const createSupplier = (supplier: Supplier): Promise<Supplier | undefined> => {
  
  const formData = new FormData();
  Object.entries(supplier).forEach(([key, value]) => {
    // Handle image separately
      formData.append(key, value);
  });

  return axios
    .post(SUPPLIER_URL, formData, {
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    })
   .then((response: any) =>
    {if(response.data.success == true){
      toast.success(response.data.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  return response.data})
    .then((response: Response<Supplier>) => response.data)
}


const updateSupplier = (supplier: Supplier): Promise<Supplier | undefined> => {
  const newFormData = new FormData();
  Object.entries(supplier).forEach(([key, value]) => {
    // Handle image separately
      newFormData.append(key, value);
  });
  // newFormData.append('_method','put');
  return axios
    .post(`${SUPPLIER_URL}/${supplier.id}`, newFormData,{
      headers: {
        'Content-Type': 'multipart/form-data', // Set the content type to multipart/form-data
      },
    })
   .then((response: any) =>
    {if(response.data.success == true){
      toast.success(response.data.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  return response.data})
    .then((response: Response<Supplier>) => response.data)
}


const deleteSupplier = (supplierId: ID): Promise<void> => {
  return axios.delete(`${SUPPLIER_URL}/${supplierId}`).then((response) => {
    if(response.data.success == true){
      toast.success(response?.data?.message,{position:'top-right'})
    }else{
      toast.error(response?.data?.message,{position:'top-right'})
    }
  })
}

const deleteSelectedSuppliers = (supplierIds: Array<ID>): Promise<void> => {
  const requests = supplierIds.map((id) => axios.delete(`${SUPPLIER_URL}/${id}`))
  return axios.all(requests).then(() => {})
}

export {
  getSuppliers,
  deleteSupplier,
  deleteSelectedSuppliers,
  getSupplierById,
  createSupplier,
  updateSupplier,
}
